import React from 'react';
import './App.css';

function ErrorPage() {


  return (

    <main className="main-content">
      <h1>Something went wrong!</h1>
      <hr></hr>
      <h2>Please check your details are correct and if the postcode is of the property we will be inspecting for you.</h2>
      <p>Please call us on 01536 534594 to talk to one of our agents if you are still encountering problems.</p>
    </main>

  );
}

export default ErrorPage;


